import { Block } from '@attom';

import CS from './CheckBox.module.scss';

export const CheckBox = ({
	// box control
	boxClass = '',
	boxSpace = '',
	boxSize = '',
	// el control
	elClass = '',
	elSpace = '',
	elSize = '',
	labelClass = '',
	// custom props
	label = '',
	value = '',
	onChange = null,
	inlineBlock = null,
	readOnly = null,
	...props
}) => {
	const isCheck = !(!value || value === 'N' || value === 'n');

	const changeHandle = () => {
		if (onChange && !readOnly) onChange(isCheck ? 'N' : 'Y');
	};

	// return jsx
	return (
		<Block boxClass={`${boxClass} ${CS.container}`} boxSize={boxSize} boxSpace={boxSpace} inlineBlock={inlineBlock}>
			<i
				className={`${elClass} ${elSize} ${elSpace}} fa fa-lg ${isCheck ? 'fa-check-square-o' : 'fa-square-o'}`}
				onClick={changeHandle}
				_readonly={`${readOnly ? 'Y' : ''}`}
			/>
			{label && (
				<span className={`mx-5px ${labelClass}`} onClick={changeHandle}>
					{label}
				</span>
			)}
		</Block>
	);
};
